import { Button, Grid, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';
import { InputLabel } from '@mui/material';
import BackupIcon from '@mui/icons-material/Backup';
import Theme from '../../../Themes/main.theme';
import { IFormController } from '../types';
import CancelIcon from '@mui/icons-material/Cancel';
import { downloadFileFullPath, removeNthEl, saveFile } from '../../../lib/helperFuncs';
import { useTranslation } from 'react-i18next';

function SimpleFileUpload(props: IFormController) {
  const { name, formik, multiple = false, accepts, onFileSelect, ...rest } = props;
  if (!formik) return <></>;
  
  const [files, setFiles] = useState(formik.values[name]
    ? Array.isArray(formik.values[name])
      ? formik.values[name]
      : [formik.values[name]]
    : []);

  const { t } = useTranslation();

  const filterOutUndefined = (
    fileArray: (string | File | undefined)[] | (string | File | undefined)
  ) => {
    if (Array.isArray(fileArray)) {
      return fileArray?.filter(
        (item: File | string | undefined) => item !== undefined);
    } else {
      if (fileArray) {
        return [fileArray];
      }
      return [];
    }
  };
  
  
  return (<>
    <Button disableRipple component='label'
      sx={{ '&:hover': { cursor: 'inherit', } }}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minWidth: 'fit-content',
        minHeight: '150px',
        border: '2px dashed #cbd5e0',
        backgroundColor: Theme?.labelColor?.background
      }}>
      <input
        accept={accepts?.toString()}
        multiple={multiple}
        {...rest}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const _files = e.target.files || [];
          let newState;
          onFileSelect && onFileSelect(e.target.files);
          if (!multiple) {
            newState = [..._files];
          } else {
            newState = [...files, ..._files];
          }
          setFiles(newState);
          formik.setFieldValue(`${name}`, newState);
          formik.setFieldTouched(name, true);
        }}
        type='file'
        hidden
      />
      <Box display='flex' justifyContent='space-evenly'
        flexDirection={{xs: 'column', md: 'row'}}
        columnGap={2} rowGap={4} >
        <Box display='flex' flexDirection='column'
          justifyContent='center' alignItems='center'>
          <BackupIcon color='primary' sx={{ fontSize: '4rem' }} />
          <Typography mt={2} color='InfoText'
            style={{ whiteSpace: 'pre-line', display: 'block', textTransform: 'none' }}>
            {t('Κάντε κλίκ για να ανεβάσετε τα αρχεία σας')}
          </Typography>
          <Typography mt={1} color='InfoText'
            style={{ whiteSpace: 'pre-line', display: 'block', textTransform: 'none' }}>
            {t('Τύπος αρχείων που υποστηρίζονται')}
            {accepts?.join(', ')}
          </Typography>
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          gap={2}>
          {formik.values[name] && filterOutUndefined(formik.values[name]).length > 0 
            && files?.map((x: any, index: number) => {
              return <>
                <Box key={`${x}`} display='flex'
                  gap={5}
                  alignItems='center'
                  justifyContent='center'>
                  <Button variant='text' 
                    sx={{'&:hover': { backgroundColor: 'transparent'} }}
                    onClick={() => typeof x == 'object'
                      ? saveFile(x)
                      : downloadFileFullPath(formik?.values[name][index])}>
                    <Typography
                      sx={{ 
                        width: '200px', whiteSpace: 'nowrap', overflow: 'hidden',
                        textOverflow: 'ellipsis'}}>
                      {
                        typeof x == 'object'
                          ? x?.name
                          : x?.split('/')?.at(-1)
                      }
                    </Typography>
                  </Button>
                  <IconButton onClick={(e: any) => {
                    e.stopPropagation();
                    e.preventDefault();
                    const newState = removeNthEl(files, index);
                    formik.setFieldValue(`${name}`, newState);
                    formik.setFieldTouched(name, true);                    
                    setFiles(newState);
                    (newState.length === 0 && onFileSelect) && onFileSelect([]);
                  }}>
                    <CancelIcon />
                  </IconButton>
                </Box>
              </>;
            })}
        </Box>
      </Box>
    </Button>
    {multiple && props.nofiles
      ? <Box display='flex' justifyContent='end'>
        {files.length} / {props.nofiles}
      </Box>
      : null
    }
  </>);
}


// wrapped in textFiled
function _FormFileUpload(props: IFormController) {
  const { label, required } = props;
  return (
    <>
      <InputLabel
        required={required}
        sx={{
          textAlign: 'left',
          textStyle: 'none',
        }}
      >
        {label}
      </InputLabel>
      <Box my={2}>
        <SimpleFileUpload {...props} />
      </Box>
    </>
  );
}

function FormFileUpload(props: IFormController) {
  return (
    <>
      <Grid>
        <Box>
          <_FormFileUpload {...props} />
        </Box>
      </Grid>
    </>
  );
}

export default FormFileUpload;